import PropTypes from 'prop-types';
import {Component} from 'react';
import {Form, TextArea} from 'semantic-ui-react';
import './Note.scss';
import OptionalTitle from './OptionalTitle';
import TextMeasurer from './TextMeasurer';

export default class Note extends Component {
  static propTypes = {
    enabled: PropTypes.bool.isRequired,
    title: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    maxLines: PropTypes.number,
    maxChars: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,

  };

  static defaultProps = {
    enabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      lines: 0,
      chars: (props.value && props.value.length) || 0,
      focused: false,
    };
  }

  componentDidUpdate(prevProps) {
    if ((!this.state.focused || this.props.value !== prevProps.value) && this.props.value !== this.state.value) {
      this.setState({value: this.props.value});
    }
  }

  onFocus = () => {
    this.setState({focused: true});
  };

  onBlur = () => {
    const {onChange} = this.props;
    const {value} = this.state;
    this.setState({focused: false});
    onChange('value', value);
  };

  onChange = (e, {value}) => {
    this.setState({chars: value.length, value});

  };

  render() {
    const {enabled = true, title, onChange, label, maxLines, maxChars, placeholder} = this.props;
    const {value, lines, chars} = this.state;
    const countMax = maxLines ? maxLines : maxChars;
    const count = maxLines ? lines : chars;
    const errorClass = count > countMax ? 'error' : '';
    let message;
    if (count > countMax) {
      message = 'limit exceeded by ' + (count - countMax);
      if (maxChars) {
        message = 'Character ' + message + ' characters';
      } else if (maxLines) {
        message = 'Line ' + message + ' lines';
      }
    } else {
      message = (countMax - count) + '/' + countMax + (maxChars ? ' characters' : ' lines') + ' remaining';
    }
    const style = {
      height: '124px',
      maxHeight: '124px',
      minHeight: '124px',
      padding: '9px',
      boxSizing: 'border-box',
      resize: 'none'
    };
    return (
      <Form className="Note">
        {label && <div className="notes-label">
          {label}
        </div>}
        {title && <div className="notes-title">
          <OptionalTitle
            title={title}
            isEnabled={enabled}
            onUpdateData={(data) => Object.keys(data).forEach(k => onChange(k, data[k]))}
            placeholder="Notes from your agent"
          />
        </div>}
        <div className={`notes-description ${errorClass}`}>
            <TextArea
              ref={this.textAreaRef}
              autoHeight
              style={style}
              disabled={!enabled}
              rows={4}
              placeholder={placeholder}
              value={value}
              onChange={this.onChange}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
            />
          <span className="text-measure-display">{message}</span>
          {maxLines && (
            <TextMeasurer text={value ? value : ''} width={502} onLinesChange={(newLines) => this.setState({lines: newLines})}/>)}
        </div>

      </Form>
    );
  }
}
